<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M22.8 16.8c.7 0 1.2.5 1.2 1.2v4.5c0 .8-.7 1.5-1.5 1.5h-21C.7 24 0 23.3 0 22.5v-21C0 .7.7 0 1.5 0H6c.7 0 1.2.5 1.2 1.2S6.7 2.4 6 2.4H3.9c-.8 0-1.5.7-1.5 1.5v16.2c0 .8.7 1.5 1.5 1.5h16.2c.8 0 1.5-.7 1.5-1.5V18c0-.7.5-1.2 1.2-1.2zM21.6 4.1v7.2c0 .4.3.8.8.8h.9c.4 0 .8-.3.8-.8V.8c-.1-.5-.4-.8-.9-.8H12.7c-.4 0-.7.3-.7.8v.9c0 .4.3.8.8.8H20L8.7 13.6c-.5.5-.5 1.2 0 1.7s1.2.5 1.7 0L21.6 4.1z"
      fill-rule="evenodd"
      clip-rule="evenodd"
    />
  </svg>
</template>
